(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("seqparse", [], factory);
	else if(typeof exports === 'object')
		exports["seqparse"] = factory();
	else
		root["seqparse"] = factory();
})(this, () => {
return 